/** Query key for draft vs generated chip navigation on the fragment video editions tab (shareable URL state). */
export const VIDEO_EDITIONS_PROJECT_GROUP_QUERY_PARAM = 'veProjectGroup';
